import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import CheckBox from "../checkbox/CheckBox";
import Input from "../textbox/Input";
import Button from "../button/Button";
import SegnalazioniService from "../../services/SegnalazioniServices";
import Utils from "../../utils/Utils";

class TableAllegati extends Component {


    constructor(props) {
        super(props);
        this.handleChangesCheckbox = this.handleChangesCheckbox.bind(this);
        this.handleChangesNoteDaCaricare = this.handleChangesNoteDaCaricare.bind(this);
        this.handleChangesNoteCaricate = this.handleChangesNoteCaricate.bind(this);
    }


    handleChangesCheckbox(index, value, isRadio, fieldname, array) {

        if (array !== undefined && array.length) {

            if (array === this.props.filesDaCaricare) {
                array[index].checked = value;
                this.props.setStatePadre({filesDaCaricare: array});
            } else if (array === this.props.filesCaricati) {
                array[index].checked = value;
                this.props.setStatePadre({filesCaricati: array});
            }

        }
    }

    handleChangesNoteCaricate(index, event) {
        let updatedRows = this.props.filesCaricati;
        if (updatedRows !== undefined && updatedRows.length) {
            updatedRows[index].note = event.target.value;
            updatedRows[index].stato = "modifica";
            this.props.setStatePadre({filesCaricati: updatedRows});
        }

    }

    handleChangesNoteDaCaricare(index, event) {
        let updatedRows = this.props.filesDaCaricare;

        if (updatedRows !== undefined && updatedRows.length) {
            updatedRows[index].note = event.target.value;
            this.props.setStatePadre({filesDaCaricare: updatedRows});
        }
    }

    render() {
        const {t} = this.props;

        const tableAllegati = (
            <div className="d-flex justify-content-center">
                <table className="table table-bordered w-75" style={{marginTop: "2rem"}}>
                    <thead>
                    <tr className="table-info" style={{fontWeight: "bold"}}>
                        <td scope="col">{t("Tables.schedaSpecialeFile.btnElimina")}</td>
                        <td scope="col">{t("Tables.schedaSpecialeFile.nome")}</td>
                        <td scope="col">{t("Tables.schedaSpecialeFile.data")}</td>
                        <td scope="col">{t("Tables.schedaSpecialeFile.note")}</td>
                        <td scope="col">{t("Tables.schedaSpecialeFile.btnVisualizza")}</td>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.props.filesCaricati.map((element, index) => {
                            return (<tr>
                                <td>
                                    <CheckBox id={"check_" + index + "_caricati"}
                                              checked={this.props.filesCaricati[index].checked}
                                              onChange={this.handleChangesCheckbox}
                                              row={this.props.filesCaricati[index]}
                                              rows={this.props.filesCaricati}
                                              disabledFlag={this.props.disabledCheckBox}
                                              index={index}
                                              deselectStyle={true}>
                                    </CheckBox>
                                </td>
                                <td>{element.nome}</td>
                                <td>{element.data}</td>
                                <td>
                                    {<Input id={"note_" + index + "_caricati"}
                                            onChange={this.handleChangesNoteCaricate}
                                            field={index}
                                            disabled={this.props.disabledCheckBox}
                                            value={element.note ? element.note : ""}
                                            placeholder={"Note"}
                                            type={"textarea"}/>}
                                </td>
                                <td>
                                    <Button text={t("SchedaFlussoSpeciale.Button.visualizza_pdf")}
                                            className="btnBlu"
                                            disabled={false}
                                            onClick={(e) => {
                                                Utils.visualizzaPdf(e, element.id,this.props.segnalazioneCopia,this.props.showSpinner)
                                            }}
                                            row={this.props.filesCaricati[index]}
                                            style={{width: "150px", height: "40px"}}>
                                    </Button>
                                </td>
                            </tr>);
                        })
                    }
                    {
                        this.props.filesDaCaricare.map((element, index) => {
                            return (<tr>
                                <td>
                                    <CheckBox id={"check_" + index + "_caricare"}
                                              checked={this.props.filesDaCaricare[index].checked}
                                              onChange={this.handleChangesCheckbox}
                                              row={this.props.filesDaCaricare[index]}
                                              rows={this.props.filesDaCaricare}
                                              index={index}
                                              deselectStyle={true}></CheckBox>
                                </td>
                                <td>{element.nome}</td>
                                <td>{element.data}</td>
                                <td>{
                                    <Input id={"note_" + index + "_caricare"}
                                           onChange={this.handleChangesNoteDaCaricare}
                                           field={index}
                                           value={element.note ? element.note : ""}
                                           placeholder={"Note"}
                                           type={"textarea"}/>}
                                </td>
                                <td>
                                    <Button text={t("SchedaFlussoSpeciale.Button.visualizza_pdf")}
                                            className="btnBlu"
                                            disabled={true}
                                            style={{width: "150px", height: "40px"}}>
                                    </Button>
                                </td>
                            </tr>);
                        })
                    }
                    </tbody>
                </table>
            </div>

        );

        return (
            <div>
                {this.props.filesCaricati.length || this.props.filesDaCaricare.length
                    ? tableAllegati
                    : null}
            </div>);
    }


}

export default withTranslation('common')(TableAllegati)
